<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { isMobile } from 'mobile-device-detect'
  import { mapActions, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import ChatConversation from './ChatConversation'
  import ChatConversations from './ChatConversations'
  import ChatNewMessage from './ChatNewMessage'

  export default {
    name: 'Chat',
    components: {
      ChatConversation,
      ChatConversations,
      ChatNewMessage,
    },
    data() {
      return {
        isMobile: isMobile,
        isStatusVisible: false,
      }
    },
    computed: {
      ...mapFields('chat', [
        'conversationId',
        'isOpen',
        'reloadUnread',
        'selectedPanel',
        'unread',
      ]),
      ...mapState('auth', ['settings']),
      classes() {
        let classes = 'chat-overlay'
        return this.isMobile ? classes += ' isMobile' : classes
      },
    },
    watch: {
      isOpen() {
        this.toggleBodyClass('no-scroll-mobile')
        this.$nextTick(() => { this.$refs.dialogTools.showScroll() })
      },
      reloadUnread(val) {
        if (val) {
          this.getUnread()
        }
      },
      '$route.query'(value) {
        this.deeplinkToConversation(value)
      },
    },
    created() {
      this.getUnread()
      if (this.$route.query) {
        this.deeplinkToConversation(this.$route.query)
      }
    },
    methods: {
      ...mapActions('chat', [
        'toggleOpen',
        'chat',
      ]),
      showStatusMessage() {
        this.isStatusVisible = true
      },
      changePanel(panel) {
        this.selectedPanel = panel
      },
      async getUnread() {
        const chat = await this.chat()
        const unreadRequest = chat.unread()
        unreadRequest && unreadRequest.then(({ data }) => {
          this.unread = data
          this.reloadUnread = false
        })
      },
      async userConversation(ids) {
        // Open or start conversation with user by user id
        // id here = user id
        const chat = await this.chat()
        chat.createDirectMessageConversation(ids).then(({ data }) => {
          this.conversationId = data.conversation_id
          this.changePanel('ChatConversation')
        })
      },
      openConversation(id) {
        // Open an existing conversation by its id
        // id here = conversation id
        this.isOpen = true
        this.conversationId = id
        this.changePanel('ChatConversation')
      },
      deeplinkToConversation(query) {
        const chat = parseInt(query.chat || 0)
        const conversation = query.conversation_id || null

        if (chat && conversation) {
          this.openConversation(conversation)
        }
      },
    },
  }
</script>
